<template>
    <div class="simple-gallery">
        <div class="images">
            <img v-for="(image, index) in images" v-bind:key="'image_' + index" v-bind:src="image" v-bind:class="{ active: index === activeIndex }" v-on:click="openImage(image)">
        </div>
        <div class="control">
            <button class="prev" v-on:click="prevImage">
                <svg focusable="false" width="24" height="24" viewBox="0 0 24 24">
                    <use href="/ui/icons/custom-sprite.svg#feather-chevron-left"></use>
                </svg>
            </button>
            <button class="next" v-on:click="nextImage">
                <svg focusable="false" width="24" height="24" viewBox="0 0 24 24">
                    <use href="/ui/icons/custom-sprite.svg#feather-chevron-right"></use>
                </svg>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            images: {
                type: Array
            }
        },
        data() {
            return {
                activeIndex: 0,
            };
        },
        methods: {
            prevImage() {
                this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;
            },
            nextImage() {
                this.activeIndex = (this.activeIndex + 1) % this.images.length;
            },
            openImage(url) {
                window.open(url, '_blank');
            }
        }
    };
</script>